import { NavLink, useLocation } from 'react-router-dom'
import { PageHeader } from '@/shared/ui/PageHeader'
import { useAuthStore } from '@/store/useAuthStore'
import { RoleAccessTab } from './RoleAccessTab'
import { UserRolesTab } from './UserRolesTab'
import { SchoolAdminAccessTab } from './SchoolAdminAccessTab'

/**
 * Roles & Access — two simple steps:
 *   1. Roles & Access: create a role and tick what it can do.
 *   2. User Roles:     give people those roles.
 * The old /roles, /permission and /mapping URLs all open step 1.
 */
export function RolesPage() {
  const location = useLocation()
  const isSchoolAdmin = useAuthStore(s => s.user?.user_type === 'school_admin')
  const base = isSchoolAdmin ? '/school/roles' : '/dashboard/roles-and-permission'

  const TABS = isSchoolAdmin
    ? [{ label: 'Roles & Access', path: `${base}/list`, key: 'access' }]
    : [
        { label: 'Roles & Access', path: `${base}/roles`, key: 'access' },
        { label: 'User Roles', path: `${base}/users`, key: 'users' },
      ]

  // Match the last URL segment only — every admin path contains "roles-and-permission".
  const last = location.pathname.replace(/\/+$/, '').split('/').pop()
  const activeKey = isSchoolAdmin ? 'access' : last === 'users' ? 'users' : 'access'

  // School dashboard: roles + permissions on the school-admin access-control API.
  const content = isSchoolAdmin ? <SchoolAdminAccessTab />
    : activeKey === 'users' ? <UserRolesTab />
    : <RoleAccessTab isSchoolAdmin={false} />

  return (
    <div className="space-y-5">
      <PageHeader title="Roles & Permissions"
        breadcrumbs={[{ label: 'Dashboard', to: isSchoolAdmin ? '/school/overview' : '/dashboard' }, { label: 'Roles & Permissions' }]} />

      {TABS.length > 1 && (
        <div className="flex border-b border-gray-100 bg-white rounded-t-xl">
          {TABS.map(t => (
            <NavLink key={t.path} to={t.path}
              className={() => `px-5 py-3 text-sm font-medium border-b-2 transition-colors ${activeKey === t.key ? 'border-brand-500 text-brand-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}>
              {t.label}
            </NavLink>
          ))}
        </div>
      )}

      {content}
    </div>
  )
}
